

//var $window = jQuery(window);
    

(function($) {
	
	'use strict';
		
	// -- Opening in a new window without target _blank -- //
	
	var elementor_init = false;
	
	function page_init(){
		'use strict';
		$(document).foundation();
		
		var $hamburger = $(".hamburger");
		$hamburger.on("click", function(e) {
			$hamburger.toggleClass("is-active");
		
		});
		
		var $jsoverlay = $(".js-off-canvas-overlay");
		$jsoverlay.on("click", function(e) {
			$hamburger.removeClass("is-active");
		});
		
		
/*
		$('.site-header').on('sticky.zf.stuckto:top', function(){
	  $(this).addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function(){
	  $(this).removeClass('shrink');
	});
*/
		
		$(".site-header, .nav_container").headroom({
		  "offset": 100,
		  "tolerance": 5,
		  "classes": {
		    "initial": "animated",
		    "pinned": "pinned",
		    "unpinned": "unpinned"
		  }
		});
		
		if($('#splash_intro').length){
			
			
			$('#splash_intro').on('click', function(e){
				e.preventDefault();
				$(this).fadeOut();
			});
			
			var splashdisplay = true;
			
			function splashControl() {
				var $cache = $('#splash_intro');
				if(splashdisplay){
					if ($(window).scrollTop() > 20){
						$cache.fadeOut();
						splashdisplay = false;
					}
					
					
					/*
					$cache.css({
					'position': 'relative',
					'top': 'auto'
					});
					*/
				}
			}
			
			$(window).scroll(splashControl);
			splashControl();
		
		}
		
		$('a[rel="external"]').on("click", function(){
			window.open( $(this).attr('href') );
			return false;
		});
		
		$('.text_content').fitVids();
		
		
		if($('#feature_slider').length){
		    $('#feature_slider').slick({
		        dots: false,
		        arrows:true,
		        autoplay:true,
		        accessibility:true,
		        fade:true,
		        speed:1200,
		        pauseOnHover:false,
		        waitForAnimate:false,
		        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
				prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>'
		    });
		} //feature_slider
		
		if(!$('body').hasClass('elementor-editor-active')){
/*
			var opentab ='';
			$('.tab_section').hide();
		
			$('.section_boxtab').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				
				var tab_to_open = $(this).find('a').first().attr('href')+'_section';
				if(opentab != tab_to_open){
					$('.tab_section').hide();
					opentab = tab_to_open;
					
					console.log(tab_to_open);
					//alert(tab_to_open);
					$(tab_to_open).fadeIn(function(){
						elementorFrontend.init();
						
						 elementorFrontend.hooks.addAction(
					        "frontend/element_ready/eael-filterable-gallery.default",
					        filterableGalleryHandler
					    );
						
					});
					//$(window).trigger('resize');
					
					 $([document.documentElement, document.body]).animate({
				        scrollTop: $(tab_to_open).offset().top-150
				    }, 1000);
			    }
			});
*/
		}
		
		doPackery();
	}
		
	$(function() {
		page_init();	
	
	});
  
  	if($('body').hasClass('elementor-editor-active')){
  
		$( window ).on( 'elementor/frontend/element_ready/global', function() {
				page_init();	
		});
		
		
		
		$( window ).on( 'elementor/frontend/init', function() {
		    //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
		    //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
		    //$scope is a jquery wrapped parent element
		    elementorFrontend.hooks.addAction( 'frontend/element_ready/shortcode.default', function($scope, $){
		        page_init();
		
		    });
		 } );
	 
	 }
	 
	 
	 var $grid;
	 
	 
	function doPackery(){
		var selector, itemSelector;

		
		selector = '.posts_grid';
		itemSelector = '.grid-item';
		
	
		

		var isotope_args = {
			itemSelector: itemSelector,
			percentPosition: true,
			columnWidth: '.news-grid-item',
			gutter: 0
		};



	

		$grid = $(selector).packery( isotope_args );
		
		
		
		
		
		}  //end doPackery
	 
	
})( jQuery );




 